export const VerifyPermits = (user, permisos, evento) => {
  if (evento?.usuarios_id == user.id) {
    return {
      boleteria: true,
      edicion: true,
      lectura: true,
    };
  }

  if (permisos.length == 0 || user.roles[0].nombre == "adm") {
    return {
      boleteria: true,
      edicion: true,
      lectura: true,
    };
  }
  let status = {
    boleteria: false,
    edicion: false,
    lectura: false,
  };

  permisos.map((permiso) => {
    if (user.id == permiso.usuario_id) {
      if (permiso.tipo == "boleteria") {
        status = { ...status, boleteria: true };
      }
      if (permiso.tipo == "edicion") {
        status = { ...status, edicion: true };
      }
      if (permiso.tipo == "lectura") {
        status = { ...status, lectura: true };
      }
    }
  });
  
  return status;
};
